import React, { Component } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
export const ButtonSkeleton = ({
  text = "Search",
  className = "btn btn-secondary btn-sm",
  iconClassName = "fas fa-search",
  iconBeforeAfterText = true,
  iconFontSize = "14px",
  showDotedLoader = false,
  dotedLoaderMarginTop = "6px",
  marginLeft = "3px",
  marginRight = "3px",
  dark = true,
}) => {
  const baseColor = dark ? "#2a2a2a" : "#e0e0e0";
  const highlightColor = dark ? "#3a3a3a" : "#f5f5f5";
  let isSuccessButton = className?.includes("btn-success");
  let isDangerButton = className?.includes("btn-danger");
  let isPrimaryButton = className?.includes("btn-primary");
  let btnCss = isSuccessButton
    ? {
        backgroundColor: `${isSuccessButton ? "#28a745" : ""}`,
        borderColor: `${isSuccessButton ? "#28a745" : ""}`,
        color: `${isSuccessButton ? "#fff" : ""}`,
      }
    : {};
  btnCss = isDangerButton
    ? {
        backgroundColor: `${isSuccessButton ? "#dc3545" : ""}`,
        borderColor: `${isSuccessButton ? "#dc3545" : ""}`,
        color: `${isSuccessButton ? "#fff" : ""}`,
      }
    : { ...btnCss };
  btnCss = isPrimaryButton
    ? {
        backgroundColor: `${isSuccessButton ? "#ff6300" : ""}`,
        borderColor: `${isSuccessButton ? "#ff6300" : ""}`,
        color: `${isSuccessButton ? "#fff" : ""}`,
      }
    : { ...btnCss };
  return (
    <button
      type="button"
      className={className}
      disabled
      style={{
        position: "relative",
        background: "transparent",
        cursor: "not-allowed",
        marginLeft,
        marginRight,
        ...btnCss,
      }}
    >
      {/* REAL text (visible) */}
      <span style={{ opacity: 0.5 }}>
        {!iconBeforeAfterText && (
          <>
            {text}
            <i
              style={{ marginLeft: "5px", fontSize: iconFontSize }}
              className={iconClassName}
            />
          </>
        )}

        {iconBeforeAfterText && (
          <>
            <i
              style={{ marginRight: "5px", fontSize: iconFontSize }}
              className={iconClassName}
            />
            {text}
          </>
        )}
      </span>
      {showDotedLoader && (
        <i
          className="buttonloader"
          style={{ marginTop: dotedLoaderMarginTop }}
        />
      )}
      {/* skeleton shimmer overlay */}
      <Skeleton
        style={{
          position: "absolute",
          inset: 0,
        }}
        baseColor="transparent"
        //baseColor={baseColor}
        highlightColor={highlightColor}
      />
    </button>
  );
};
